import React from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { X } from "lucide-react";
import "../styles/carnet.css";

export default function Carnet() {
  const navigate = useNavigate();
  const location = useLocation();

  const petFromState = location.state?.pet;

  // 🔒 Si no llega mascota por state, redirige a interfaz
  if (!petFromState) {
    return <Navigate to="/interfaz" replace />;
  }

  const pet = petFromState;

  return (
    <main className="carnet-shell">
      <button
        className="carnet-close"
        onClick={() => navigate(-1)}
        aria-label="Cerrar carnet"
      >
        <X size={18} />
      </button>

      <section className="carnet-card">
        <header className="carnet-header">
          <h1 className="carnet-title">CARNET DE VACUNACIÓN</h1>
          <p className="carnet-pet">{pet.nombre}</p>
          <p className="carnet-breed">{pet.raza}</p>
        </header>

        <div className="carnet-body">
          <div className="carnet-table">
            <div className="carnet-header-row">
              <span>Fecha</span>
              <span>Vacuna</span>
              <span>Peso</span>
              <span>Firma</span>
            </div>

            {/* Filas vacías */}
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} className="carnet-row">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}